export async function checkUsername(desired: string, sessionId?: string) {
  const r = await fetch('/api/identity/check-username', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ desired, sessionId }),
  });
  if (!r.ok) {
    // Degrade gracefully for any server error (5xx) or unavailability (503/502)
    // so the signup form stays usable even during brief server restarts.
    return { available: true, username: desired, suggestions: [] as string[] };
  }
  return r.json() as Promise<{ available: boolean; username?: string; suggestions: string[] }>;
}

export async function suggestUsernames(base: string) {
  const r = await fetch('/api/identity/suggest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ base }),
  });
  if (!r.ok) throw new Error('Suggest failed');
  return r.json() as Promise<{ base: string; candidates: { username: string; available: boolean }[] }>;
}

export type SignupAtomicInput = {
  name: string;
  email: string;
  password?: string;
  phone?: string;
  company?: string;
  position?: string;
  location?: string;
  avatarUrl?: string | null;
  coverUrl?: string | null;
  templateKey?: string;
  gender?: string;
  age?: number | string;
  preferredHandle?: string; // non-unique
  desiredUsername: string; // unique
  sessionId?: string;
};

export async function signupAtomic(input: SignupAtomicInput) {
  const r = await fetch('/api/auth/signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!r.ok) {
    try {
      const body = await r.json();
      throw new Error(JSON.stringify(body));
    } catch {
      throw new Error(await r.text());
    }
  }
  return r.json() as Promise<{ token: string; user: any; card: any }>;
}

export async function reserveUsername(username: string, sessionId: string, ttlMinutes = 30) {
  const r = await fetch('/api/identity/reserve', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, sessionId, ttlMinutes }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json() as Promise<{ ok: boolean; username: string; expiresAt: string }>;
}

export async function releaseReservation(username: string, sessionId?: string) {
  const qs = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : '';
  await fetch(`/api/identity/reserve/${encodeURIComponent(username)}${qs}`, { method: 'DELETE' });
}
